import React, { useState, useContext, useEffect } from 'react'
import DetailCardWithTable from '../../../dpe-usco/components/Details/DetailCardWithTable'
import { Button, Modal } from 'syngenta-react-components'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import { convertToTitleCase, convertToSentenceCase, formatPhoneNumber } from '../../../services/utils'
import LinkedCompaniesForm from './LinkedCompaniesForm'
import { AuthContext, GlobalContext } from '../../../services/context'
import Warning from '../../../components/subComponents/Notifications/Warning'
import deleteIcon from '../../../assets/icons/close.svg'
import { deleteLinkCompanies } from '../../../services/apiHelper'
import HeaderFilter from '../../../components/subComponents/HeaderFilter'

export const LinkedCompanies = ({ data, status, _getLinkCompanies, company_id, parentCompanyName, customSort }) => {
  const { trackEvent } = useContext(GlobalContext)
  const { hasAccess } = useContext(AuthContext)
  const [showModal, setShowModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedCompanyName, setSelectedCompanyName] = useState()
  const [selectedCompanyID, setSelectedCompanyID] = useState()
  const [isLoading, setIsLoading] = useState(false)
  

  const [companiesData, setCompaniesData] = useState()
  
  useEffect(() => {
    setCompaniesData(data)
  }, [data])

  const headerCell = (value, dataKey) => {
    const acendCallBack = () => {
      setCompaniesData(customSort(data, dataKey, 'asc'))
    }

    const decendCallBack = () => {
      setCompaniesData(customSort(data, dataKey, 'desc'))
    }

    return (
      <div key={value} className="cell df aic">
        <span>{value}</span>
        <HeaderFilter
          dataKey={dataKey}
          descend={() => decendCallBack()}
          ascend={() => acendCallBack()}
        />
      </div>
    )
  }
  
  const linkCompanyStructure = {
    headers: [
      {
        value: 'Name',
        format() {
          return headerCell(this.value, 'name')
        }
      },
      {
        value: 'Type',
        format() {
          return headerCell(this.value, 'type')
        }
      },
      {
        value: 'City',
        format() {
          return headerCell(this.value, 'city')
        }
      },
      {
        value: 'Phone',
        format() {
          return headerCell(this.value, 'phone')
        }
      },
      {
        value: '',
        format() {
          return <div key={this.value} className='cell df aic'>
            <span>{this.value}</span>
          </div>
        }
      }
    ],
    dataKeys: [
      'name', 'type', 'city', 'phone', 'companyInfo'
    ],
    rowFormat: {
      name: {
        format: name => {
          return (
            <div>
              {convertToTitleCase(name)}
            </div>
          )
        }
      },
      type: {
        format: type => {
          return (
            <div>
              {convertToSentenceCase(type)}
            </div>
          )
        }
      },
      city: {
        format: city => {
          return (
            <div>
              {convertToTitleCase(city)}
            </div>
          )
        }
      },
      phone: {
        format: phone => {
          return (
            <div>
              {formatPhoneNumber(phone)}
            </div>
          )
        }
      },
      companyInfo: {
        format: companyInfo => {
          let val = hasAccess() === 'SUCCESS' ? <div className='w100% tar'>
            <button onClick={() =>{
              clickDeletePrompt(companyInfo)}}  className='bgc-t bdnone curp fz15 fw700 pr20'>
              <img
                alt='delete button icon'
                src={deleteIcon}/>
            </button>
          </div> : ' '
          return val
        }
      }
    }
  }

  const confirmDelete = async () => {
    setIsLoading(true)
    await deleteLinkCompanies(selectedCompanyID, company_id)
    _handleClose()
    trackEvent('remove_linked_company_confirmed', { companyId: company_id })
  }

  const clickDeletePrompt = companyInfo => {
    setSelectedCompanyName(companyInfo.name)
    setSelectedCompanyID(companyInfo.id)
    setShowDeleteModal(true)
    setShowModal(true)
    trackEvent('remove_linked_company_clicked', { companyName: companyInfo.name, companyId: companyInfo.id })
  } 

  const _handleClose = result => {
    setSelectedCompanyName()
    setSelectedCompanyID()
    setShowModal(false)
    setShowDeleteModal(false)
    if (result !== 'CLOSE') {
      _getLinkCompanies(company_id)
    }
  }

  const linkCompanies = () => {
    setShowModal(true)
    trackEvent('link_companies_clicked', { companyId: company_id })
  }

  const renderButton = () => {
    return hasAccess() === 'SUCCESS' ? <Button type='success' text='Link Companies' clickHandler={linkCompanies}/> : null
  }

  return (
    <div className='mb25'>
      <DetailCardWithTable
        button={renderButton()}
        title={'Linked Companies'}
        structure={linkCompanyStructure}
        data={companiesData}
        statusComponent={status? <TableStatus status={status} prompt='There are currently no companies linked'/>  : null}
      />
      <Modal
        autoHeight
        show={showModal}
        handleClose={() => setShowModal(false)}
      >
        {
          showDeleteModal 
            ?  <Warning
              warningMessage={isLoading ? `Deleting ${selectedCompanyName} from ${parentCompanyName}, please wait...` : `You are about to delete ${selectedCompanyName} from ${parentCompanyName} company's list. Are you sure?`}
              confirmationButtonText='Yes, delete'
              handleSubmit={confirmDelete}
              handleDismissWarning={_handleClose}/> 
            : <LinkedCompaniesForm handleClose={result => _handleClose(result)} parentCompanyName={parentCompanyName} _getLinkCompanies={_getLinkCompanies}/>
        }
      </Modal>
    </div>
  )
}

export default LinkedCompanies
